import { IFitmentOption } from "interfaces/session/IVehicle";

export function getFitmentOptionObj(fitmentOptions: IFitmentOption[] = []) {
  const queryParams = {};
  fitmentOptions?.forEach((fo) => {
    if (queryParams["fo.name"]) {
      queryParams["fo.name"].push(fo.optionName);
    } else {
      queryParams["fo.name"] = [fo.optionName];
    }
    if (queryParams["fo.value"]) {
      queryParams["fo.value"].push(fo.optionValue);
    } else {
      queryParams["fo.value"] = [fo.optionValue];
    }
  });
  return queryParams;
}
